/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.cartRefreshHandler       = this.cartRefreshHandler.bind(this);

    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);

    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach(el => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach(el => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);


document.addEventListener('DOMContentLoaded', () => {
  const checkbox      = document.getElementById('delivery_checkbox');
  const weekContainer = document.getElementById('delivery_week_container');
  const weekSelect    = document.getElementById('delivery_week');
  const checkoutLink  = document.querySelector('.checkout-buttons a');

  // Kovakoodattu prefix kielikoodin perusteella
  function getWeekPrefix() {
    const lang =
      (window.Shopify && Shopify.locale) ||
      document.documentElement.lang ||
      navigator.language ||
      'en';
    const lc = String(lang).toLowerCase();
    if (lc.startsWith('fi')) return 'Viikko';
    if (lc.startsWith('sv')) return 'Vecka';
    if (lc.startsWith('de')) return 'Woche';
    return 'Week';
  }

  // Näytä/piilota viikkivalikko
  checkbox.addEventListener('change', () => {
    weekContainer.classList.toggle('hidden', !checkbox.checked);
  });

  // Intercept kassalle klikkauksen
  checkoutLink.addEventListener('click', async (evt) => {
    if (!checkbox.checked) return;   // jos ei valittu, mennään normaalisti
    evt.preventDefault();

    const selectedWeek  = weekSelect.value;           // haetaan valittu viikko
    const propLabel     = window.DELIVERY_PROP_LABEL; // käännetty property-avain
    const weekPrefix    = getWeekPrefix();            // FI/SV/DE/Week

    try {
      // 1) Hae nykyinen ostoskori JSONina
      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();

      // 2) Päivitä jokainen rivi erikseen
      for (const item of cart.items) {
        const newProps = { ...item.properties };
        newProps[propLabel] = `${weekPrefix} ${selectedWeek}`;

        await fetch('/cart/change.js', {
          method:  'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept':       'application/json'
          },
          body: JSON.stringify({
            id:         item.key,
            quantity:   item.quantity,
            properties: newProps
          })
        });
      }

      // 3) Kun kaikki rivit päivitetty, ohjaa kassalle
      window.location.href = checkoutLink.href;

    } catch (error) {
      console.error('Delivery week update failed:', error);
      alert(window.DELIVERY_CHECKBOX_LABEL + ' päivitys epäonnistui – yritä hetken päästä uudelleen.');
    }
  });
});
